PJQ.views.projects.AutoReport = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Auto-Report'),
        minWidth: '800px'
    },
    events: {
        'click .export-pdf': 'exportPDF'
    },
    afterRender: function() {
        // fetch and display the report contents (in HTML format)
        let loader = new PJQ.Loader(this.$('div.report-content'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'autoreport'
                }
            ])
        }).get().done(_.bind(function (response) {
            loader.remove();
            jQuery('div.report-content').html(atob(response.data));
            jQuery('div.report-content div div table tbody tr td[width="100%"]').attr('width', '0px');
        }, this));
    },
    exportPDF: function() {
        // export the report to PDF and serve up the download.
        PJQ.files.downloadFile(
            PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'autoreport'
                },
                {
                    endpoint: 'export'
                }
            ])
        );
    }
});